import { atom } from 'jotai';

type AlarmId = string;
type Timestamp = number;

export const alarmsRenderedTimeAtom = atom<Record<AlarmId, Timestamp>>({});
